/**
 * 악덕업체 마스터 (/adm/devil/masters) — 목록 + 통합 모달($j.F.Admin.Devil.Case)
 * ($j.Pages.Admin.DevilMasters / body data-page-name="DevilMasters")
 *
 * 상태 이름표(마스터·신고·소명)는 컨트롤러가 #page-data 로 넘긴다.
 */
export default class DevilMasters {
    initialize() { initialize(); }
}

let DV_MASTER_STATUS = {}, DV_REPORT_STATUS = {}, DV_DEFENSE_STATUS = {};
let $table = null;

function initialize() {
    const d = JSON.parse(document.getElementById('page-data').textContent);
    DV_MASTER_STATUS  = d.master;
    DV_REPORT_STATUS  = d.report;
    DV_DEFENSE_STATUS = d.defense;

    $('#dvmSearch').on('click', reloadTable);
    $('#dvmReset').on('click', resetFilter);
    $('#dvmTestCall').on('click', () => $j.F.Admin.Devil.TestCall.open({ labels: DV_MASTER_STATUS, onDone: reloadTable }));
    // 업체명 → 통합 모달, 통화 수 → 통화 목록
    $('#master-table').on('click', 'a[data-dvm]', function (e) {
        e.preventDefault();
        const n = Number(this.dataset.n);
        if (this.dataset.dvm === 'detail') showDetail(n);
        else $j.F.Admin.Devil.Master.openCalls(n);
    });

    $j.F.Admin.Devil.Case.config({
        labels: { master: DV_MASTER_STATUS, report: DV_REPORT_STATUS, defense: DV_DEFENSE_STATUS },
        onChanged: reloadTable,
    });
    loadTable();
    bindKeywordAutocomplete();
    // 검색칸에서 엔터 → 조회 (신고목록과 동일). 모듈 최상위에 두면 adm.js 가 모든 화면에서 걸어 버린다
    $(document).on('keydown', '#f_keyword', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); reloadTable(); }
    });
}

// 검색창 자동완성 — 업체명/대표자. 선택 시 업체명으로 조회. (공용 헬퍼: 키보드 ↓/↑/Enter/Esc)
function bindKeywordAutocomplete() {
    $j.F.Admin.Util.autocomplete('#f_keyword', {
        url: '/adm/ajax/devil/masters/search',
        render: r => {
            const ceo = r.ceo_name ? ` <small class="text-muted">대표 ${escapeHtml(r.ceo_name)}</small>` : '';
            const badge = `<span class="badge-status badge-${r.status} dvm-ac-badge">${escapeHtml(DV_MASTER_STATUS[r.status] || r.status)}</span>`;
            return `${escapeHtml(r.co_name || '-')}${ceo} ${badge} <small class="text-muted">· 제보 ${r.report_cnt}</small>`;
        },
        pick: r => { $('#f_keyword').val(r.co_name); reloadTable(); },
    });
}

function loadTable() {
    const columns = [
        {data: 'num', title: '#', width: '60px'},
        {data: 'co_name', title: '업체명', width: '240px',
            render: (v, _, row) => `<a href="#" class="cell-detail" data-dvm="detail" data-n="${row.num}">${escapeHtml(v || '-')}</a>`},
        {data: 'ceo_name', title: '대표자', width: '90px', render: v => v || '-'},
        {data: 'rep_phone', title: '대표번호', width: '160px', render: v =>
            v ? escapeHtml($j.Common.Util.phoneNumber(v) || v) : '<span class="text-muted">-</span>'},
        {data: 'unpaid_total', title: '체불합계', width: '140px', className: 'text-right',
            render: v => `<b>${v}</b>`},
        {data: 'recovered', title: '회수금액', width: '130px', className: 'text-right',
            render: v => (v && v !== '0') ? `<span class="dvm-recovered">${v}</span>` : '<span class="text-muted">-</span>'},
        {data: 'report_cnt', title: '제보', width: '60px', className: 'text-center'},
        {data: 'call_cnt', title: '통화', width: '60px', className: 'text-center',
            render: (v, _, row) => Number(v) > 0
                ? `<a href="#" class="cell-detail" data-dvm="calls" data-n="${row.num}">${v}</a>`
                : '<span class="text-muted">0</span>'},
        {data: null, title: '상태', width: '120px', className: 'text-center',
            // 해제된 줄은 누가 언제 풀었는지를 작게 — 제보자 회수(자동) / 관리자 이름 · 월-일 시:분
            render: r => statusBadge(r.status) + (r.status === 'RELEASED' && r.released_by
                ? `<div class="text-muted small">${escapeHtml(r.released_by)} · ${escapeHtml(r.released_at)}</div>` : '')},
        {data: 'created_at', title: '등록일', width: '150px', render: v => $j.Common.Util.formatDateTime(v)},
    ];

    if ($table) { $table.destroy(); $('#master-table').empty(); }

    $table = new DataTable('#master-table', {
        autoWidth: false,
        columns,
        headerCallback: thead => $(thead).find('th').css('text-align', 'center'),
        ajax: {
            url: '/adm/ajax/devil/masters/list',
            type: 'post',
            data: d => Object.assign(d, {
                status:  $('#f_status').val(),
                keyword: $('#f_keyword').val(),
            })
        },
        language: {
            emptyTable: '데이터가 없습니다.',
            info: '_TOTAL_ 건',
            infoFiltered: '',
            loadingRecords: '로딩 중...',
            zeroRecords: '일치하는 결과가 없습니다.',
            paginate: {previous: "<i class='fa fa-chevron-left'></i>", next: "<i class='fa fa-chevron-right'></i>"}
        },
        order: [[0, 'desc']],
        pageLength: 25,
        lengthChange: false,
        searching: false
    });
}

function reloadTable() { $table && $table.ajax.reload(); }

function resetFilter() {
    $('#f_status').val('');
    $('#f_keyword').val('');
    reloadTable();
}

// 통합 모달 — 좌측 마스터(제보 클릭 → 우측 신고/소명 펼침). config 에서 labels/onChanged 설정됨.
function showDetail(num) {
    $j.F.Admin.Devil.Case.openMaster(num);
}

function statusBadge(s) {
    return `<span class="badge-status badge-${s}">${escapeHtml(DV_MASTER_STATUS[s] || s)}</span>`;
}

function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, c => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]));
}
